import UIController from '@ui/controllers/UIController'

export default UIController()
